import { datadogRum } from '@datadog/browser-rum';

type EventName<T> = T extends string
  ? T extends 'click' | 'change' | 'submit'
    ? never
    : T
  : never;

/**
 * @link https://developers.heap.io/reference/track
 */
export const trackEvent = <T>(
  event: EventName<T>,
  properties?: Record<string, string | number | boolean>,
) => {
  datadogRum.addAction(event, properties);
  try {
    window.heap?.track(event, properties);
  } catch (error) {
    datadogRum.addError(new Error('Heap trackEvent failed'), {
      event,
      properties,
      error,
    });
  }
};
